import { ShortcutItem } from "src/shared/shortcut-item";
import { emitter } from "boot/mitt";

export default function (shortcut: ShortcutItem) {
  emitter.emit("trigger-shortcut", {
    shortcut: shortcut,
  });
}
